import { __decorate, __metadata } from "tslib";
import { DiningOptionEnum, IsUndefinable, IsUUIDWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsString, MaxLength } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
export class ReadDiningOptionInfoDto {
}
__decorate([
    ApiProperty({ enum: DiningOptionEnum, example: DiningOptionEnum.TAKE_OUT }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadDiningOptionInfoDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => Object, description: 'depends on schema for specific store (will be used on FE, to fill the form)' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", Object)
], ReadDiningOptionInfoDto.prototype, "details", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'stringified version of details', example: 'Car make Tesla, Car model S' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadDiningOptionInfoDto.prototype, "summary", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => String,
        description: 'stringified version of details with address details',
        example: 'Address: 45 Palatine, Irvine, CA 92612, USA, \nComments: 133',
    }),
    Expose({ groups: [CartExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadDiningOptionInfoDto.prototype, "legacySummary", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'only for cart and orders with delivery' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadDiningOptionInfoDto.prototype, "deliveryZoneUuid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'only for cart and orders with curbside' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", Object)
], ReadDiningOptionInfoDto.prototype, "arrivedAt", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'only for cart and orders with curbside' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadDiningOptionInfoDto.prototype, "arrivalNotes", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'for POS check/receipt' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadDiningOptionInfoDto.prototype, "deliveryZoneTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Guid' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadDiningOptionInfoDto.prototype, "guid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'uuid' }),
    IsUndefinable({ always: true }),
    IsUUIDWithLVS('4'),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadDiningOptionInfoDto.prototype, "uuid", void 0);
//# sourceMappingURL=ReadDiningOptionInfoDto.js.map